<template>
	<div class="vehicle-tag" v-bind:class="backgroundColor">
		<div class="vehicle">{{vehicle}}</div>
		<div class="fireunit">{{fireunit}}</div>
	</div>
</template>

<script>
export default {
	name: 'VehicleTag',
	props: {
		vehicle: { type: String, required: true },
		fireunit: { type: String, required: true },
		color: { type: String, default: 'BLANC' }
    },
	computed: {
		backgroundColor() {
			return this.color.toLowerCase() + '-background'
		}
	}
};
</script>

<style scoped>
.vehicle-tag {
    display: inline-block;
    font-size: 10px;
	line-height: 10px;
    padding: 4px 10px;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
	min-width: 72px;
}

.vehicle-tag > div {
	text-align: center;
}

</style>

